import ReactDOM from 'react-dom/client';
import React from 'react';
export const EnemyDeckExample =  ()=>{
    return (
        <div className="container">
            <h2>使い方</h2>
              EnemyDeckはNPCの構築済みデッキです
            <p>
            <img src={`${process.env.PUBLIC_URL}/enemy_deck_example.png`}></img>
            </p>
            <p>基本的に通常のデッキ構築と同様に構築していきます</p>
            
        </div>
    )
}
